var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasta({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29272 8.13242V5.85892C9.29272 5.23111 9.82439 4.72217 10.4802 4.72217H14.6365C15.2923 4.72217 15.824 5.23111 15.824 5.85892V8.13242M5.73022 19.4999H19.9802C21.2919 19.4999 22.3552 18.4821 22.3552 17.2264V10.4059C22.3552 9.15031 21.2919 8.13242 19.9802 8.13242H5.73022C4.41855 8.13242 3.35522 9.15031 3.35522 10.4059V17.2264C3.35522 18.4821 4.41855 19.4999 5.73022 19.4999Z",
    stroke: "#265DAF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasta);
export default __webpack_public_path__ + "static/media/pasta.f5ead245bbed1b5097a5b3e97b456370.svg";
export { ForwardRef as ReactComponent };